module.exports = __webpack_public_path__ + "img/login_bottom.2ded667e.png";